// import React, { useEffect } from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import { AuthProvider } from "./contexts/AuthContext";
// import Navbar from "./components/Navbar";
// import ProtectedRoute from "./components/ProtectedRoute";
// import Home from "./pages/Home";
// import Login from "./pages/Login";
// import Signup from "./pages/Signup";
// import Dashboard from "./pages/Dashboard";
// import About from "./pages/About";
// import Contact from "./pages/Contact";
// import TrackingCapture from "./pages/TrackingCapture";
// import TermsAndConditions from "./pages/TermsAndConditions";
// import ResetPassword from "./pages/ResetPassword";
// import LinkGenerator from "./pages/Linkgenerator";

// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:5001";

// export default function App() {
//   // Keep-warm ping — wakes Render on load, then pings every 10 min to
//   // prevent the free tier from sleeping (it sleeps after 15 min of inactivity).
//   useEffect(() => {
//     const ping = () => fetch(`${BACKEND_URL}/`, { method: "GET" }).catch(() => { });
//     ping(); // immediate ping on load
//     const interval = setInterval(ping, 10 * 60 * 1000); // every 10 minutes
//     return () => clearInterval(interval); // cleanup on unmount
//   }, []);

//   return (
//     <Router>
//       <AuthProvider>
//         <Routes>
//           <Route path="/t/:token/*" element={<TrackingCapture />} />
//           <Route path="*" element={
//             <div className="min-h-screen bg-surface">
//               <Navbar />
//               <Routes>
//                 <Route path="/" element={<Home />} />
//                 <Route path="/login" element={<Login />} />
//                 <Route path="/signup" element={<Signup />} />
//                 <Route path="/about" element={<About />} />
//                 <Route path="/contact" element={<Contact />} />
//                 <Route path="/terms" element={<TermsAndConditions />} />
//                 <Route path="/reset-password" element={<ResetPassword />} />
//                 <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
//                 <Route path="/generate" element={<LinkGenerator />} />
//               </Routes>
//             </div>
//           } />
//         </Routes>
//       </AuthProvider>
//     </Router>
//   );
// }
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import Navbar from "./components/Navbar";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Dashboard from "./pages/Dashboard";
import About from "./pages/About";
import Contact from "./pages/Contact";
import TrackingCapture from "./pages/TrackingCapture";
import TermsAndConditions from "./pages/TermsAndConditions";
import ResetPassword from "./pages/ResetPassword";
import LinkGenerator from "./pages/Linkgenerator";
import Vouchers from "./pages/Vouchers";
import BlogPage from "./pages/BlogPage";
import ForensicBot from "./pages/ForensicBot";
import Tools from "./pages/Tools";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:5001";

export default function App() {
  // Keep-warm ping — wakes Render on load, then pings every 10 min to
  // prevent the free tier from sleeping (it sleeps after 15 min of inactivity).
  useEffect(() => {
    const ping = () => fetch(`${BACKEND_URL}/`, { method: "GET" }).catch(() => { });
    ping(); // immediate ping on load
    const interval = setInterval(ping, 10 * 60 * 1000); // every 10 minutes
    return () => clearInterval(interval); // cleanup on unmount
  }, []);

  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/t/:token/*" element={<TrackingCapture />} />
          <Route path="/r/:token/*" element={<TrackingCapture />} />
          <Route path="*" element={
            <div className="min-h-screen bg-surface">
              <Navbar />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/terms" element={<TermsAndConditions />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                <Route path="/generate" element={<LinkGenerator />} />
                <Route path="/vouchers" element={<ProtectedRoute><Vouchers /></ProtectedRoute>} />
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/forensic-bot" element={<ForensicBot />} />
                <Route path="/tools" element={<Tools />} />
              </Routes>
            </div>
          } />
        </Routes>
      </AuthProvider>
    </Router>
  );
}